<template>
  <section id="contact_" class="col-md-12">
              <div class="card-body" style="margin: 30px">
                <form id="form_contact" class="row g-3" @submit.prevent="submitForm" autocomplete="off">

                  <div class="col-md-6">
                    <label for="name" class="form-label title_form">Nombre</label>
                    <input type="text" class="form-control back_form" id="name" v-model="formData.name" maxlength="20" @keypress="onlyText">
                  </div>
                  <div class="col-md-6">
                    <label for="email" class="form-label title_form">Correo electrónico</label>
                    <input type="email" class="form-control back_form" id="email" v-model="formData.email" maxlength="40" @keypress="validateEmailInput">
                  </div>
                  <div class="col-12">
                    <label for="subject" class="form-label title_form">Asunto</label>
                    <input type="text" class="form-control back_form" id="subject" v-model="formData.subject" maxlength="40">
                  </div>
                  <div class="col-12">
                    <label for="message" class="form-label title_form">Mensaje</label>
                    <textarea class="form-control back_form" id="message" name="message" rows="8" cols="80" v-model="formData.message" maxlength="500"></textarea>
                  </div>

                  <div class="mb-3">
                    <div class="g-recaptcha" data-sitekey="6LdP5-wnAAAAAPXiOXlXAD0dybIsk4Ac-5gl2eL5"></div>
                  </div>
                  <div class="col-12" v-if="!sendState">
                    <button class="btn btn-primary" type="submit" value="Submit" style="background-color: #232323;">Enviar</button>
                  </div>
                  <div class="col-12" v-else>
                    <button class="btn btn-primary" style="background-color: #232323;" disabled>Enviando...</button>
                  </div>

                </form>
              </div>
  </section>
</template>

<script>
/* global grecaptcha */
  import axios from 'axios';
  import store from "../store";
  import Swal from 'sweetalert2'
  
  export default {
    data() {
      return {
        urlBack: store.state.urlBack,
        sendState: false,
        formData: {
          name: '',
          email: '',
          subject: '',
          message: '',
          captcha: ''
        }
      };
    },
    methods: {
      async submitForm() {

        if(grecaptcha.getResponse().length === 0){
          
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            }
          });
          Toast.fire({
            icon: "error",
            title: "Debe completar el captcha"
          });

          return
        }

        if(!this.validaForm()){
          return false
        }

        this.sendState = true

        this.formData.captcha = grecaptcha.getResponse()
      
        try {
          const response = await axios.post(this.urlBack + 'send-mail.php', this.formData, {
              headers: {
                  'Content-Type': 'application/json', // Cambia esto según lo que envíes
              }
          });
          
          if(response.data['response_back'] == '200'){
              console.log('Correo enviado con exito');

              this.sendState = false
              const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
              }
            });
            Toast.fire({
              icon: "success",
              title: "Correo enviado"
            });
          }
          
          // Reiniciar el formulario después del envío
          this.formData.name = '';
          this.formData.email = '';
          this.formData.subject = '';
          this.formData.message = '';
          grecaptcha.reset();
        } catch (error) {
            console.error(error);
        }
      },
      validaForm(){

          var msn = 'Debe por completar: \n'
          var a = 0

          if(this.formData.name == ""){  
            msn += '- Nombre.\n'
            a+=1
          }

          if(this.formData.email == ""){     
            msn += '- Correo electrónico.\n'
            a+=1
          }

          if(this.formData.subject == ""){     
            msn += '- Asunto.\n'
            a+=1
          }

          if(this.formData.message == ""){     
            msn += '- Mensaje.\n'
            a+=1
          }
   
          if(a != 0){
            const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
              }
            });
            Toast.fire({
              icon: "error",
              title: msn
            });
            return false
          }else{
            return true
          }
      },
      onlyText($event) {
        const charCode = $event.charCode || $event.keyCode;
        const char = String.fromCharCode(charCode);

        // Expresión regular para permitir solo letras (incluyendo con tildes y ñ) y espacios
        const regex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]$/;

        if (!regex.test(char)) {
          $event.preventDefault(); // Evitar que se introduzca el carácter
        }
      },
      validateEmailInput($event) {
        const charCode = $event.charCode || $event.keyCode;
        const char = String.fromCharCode(charCode);

        // Expresión regular para permitir caracteres válidos en correos electrónicos
        const regex = /^[A-Za-z0-9@._-]$/;

        // Si el carácter no coincide con el regex, prevenir su entrada
        if (!regex.test(char)) {
          $event.preventDefault();
        }
      },
    }
  };
</script>
<style scoped>
.title_form{
  color: #000000;
}
.back_form{
  background-color: #ffffff;
}
</style>
